module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('AppSteppers', {
    attrs: {
      "start-step-name": "Данные пользователя"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var prevStep = ref.prevStep;
        var nextStep = ref.nextStep;

        return [_c('AppSteppersPane', {
          attrs: {
            "step-name": "Данные пользователя"
          }
        }, [_c('DynamicAdditionalDataForm', {
          attrs: {
            "next-step": nextStep
          }
        })], 1), _c('AppSteppersPane', {
          attrs: {
            "step-name": "Оформление заявки"
          }
        }, [_c('div', {
          staticClass: "consultation_modal_root"
        }, [_c('div', {
          staticClass: "consultation_modal"
        }, [_c('main', {
          staticClass: "consultation_modal_form"
        }, [_c('div', {
          staticClass: "consultation_block"
        }, [_c('Select', {
          staticClass: "consultation_block_select",
          attrs: {
            "options": _vm.getOptions,
            "placeholder": "Тема обращения (обязательно к заполнению)",
            "required": true,
            "value": _vm.value
          },
          model: {
            value: (_vm.value),
            callback: function($$v) {
              _vm.value = $$v
            },
            expression: "value"
          }
        }), _c('Textarea', {
          staticClass: "consultation_block_input",
          attrs: {
            "min-height": "170px",
            "placeholder": "Текст обращения (обязательно к заполнению)",
            "resize": "vertical"
          },
          model: {
            value: (_vm.value1),
            callback: function($$v) {
              _vm.value1 = $$v
            },
            expression: "value1"
          }
        }), _c('div', {
          staticClass: "appendButton"
        }, [_c('ExtButton', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.$refs.inputFile.click()
            }
          }
        }, [_vm._v("выберите файлы"), _c('span', [_vm._v("*")])]), _c('p', {
          attrs: {
            "title": _vm.getTitleFiles
          }
        }, [_vm._v(_vm._s(_vm.getFilesNames))])], 1), (_vm.value2.length > 0) ? _c('p', {
          staticClass: "alertify"
        }, [_vm._v("Вы можете загрузить один или несколько файлов одновременно. Последующая загрузка файлов приведет к замене уже загруженных файлов.")]) : _vm._e(), _c('p', {
          staticClass: "title_files"
        }, [_vm._v("Допустимые типы файлов: GIF, JPG, TIF, PNG, pdf, zip. Общий объем загружаемых файлов - не более 2 мб.")]), _c('input', {
          ref: "inputFile",
          staticClass: "file_attach",
          staticStyle: {
            "display": "none"
          },
          attrs: {
            "name": "attachments[]",
            "type": "file",
            "accept": ".gif,.jpg,.tif,.png,.pdf,.zip",
            "multiple": "multiple"
          },
          on: {
            "change": function($event) {
              _vm.value2 = $event.target.files
            }
          }
        })], 1)]), _c('div', {
          staticClass: "save_button_wrapper"
        }, [_c('Button', {
          staticClass: "save_button",
          attrs: {
            "disabled": !_vm.isActive
          },
          on: {
            "click": function($event) {
              return _vm.send(nextStep)
            }
          }
        }, [_vm._v("Сохранить")])], 1), (_vm.critError) ? _c('p', {
          staticClass: "alert red"
        }, [_vm._v(_vm._s(_vm.critError))]) : (_vm.error) ? _c('p', {
          staticClass: "alert red"
        }, [_vm._v("Не заполнены обязательные поля")]) : _vm._e()])])]), _c('AppSteppersPane', {
          attrs: {
            "step-name": "Статус"
          }
        }, [_c('FinishMessage', {
          attrs: {
            "message": _vm.message
          },
          on: {
            "understood": function($event) {
              return _vm.$ui.$modal.close("ConsultationModal")
            }
          }
        })], 1)]
      }
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68e03bc1","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ordersProcessForms/consultation/ConsultationsModal.vue
// module id = eb832ad985979b34d278
// module chunks = 0